import type { VisibilityConditionValueType } from '../../visibility-condition.interfaces';
import { BooleanTargetValueConverter } from './boolean-target-value-converter';
import { DateTargetValueConverter } from './date-target-value-converter';
import { EntityIdTargetValueConverter } from './entity-id-target-value-converter';
import type { ITargetValueConverter } from './i-target-value-converter';
import { NumberTargetValueConverter } from './number-target-value-converter';
import { StringTargetValueConverter } from './string-target-value-converter';
import { TrainingTargetValueConverter } from './training-target-value-converter';

export class TargetValueConverterFactory {
  public static getConverter(
    targetValueType?: VisibilityConditionValueType,
  ): ITargetValueConverter | undefined {
    if (targetValueType) {
      switch (targetValueType) {
        case 'ENTITY_ID':
          return new EntityIdTargetValueConverter();
        case 'STRING':
          return new StringTargetValueConverter();
        case 'NUMBER':
          return new NumberTargetValueConverter();
        case 'BOOLEAN':
          return new BooleanTargetValueConverter();
        case 'DATE':
          return new DateTargetValueConverter();
        case 'TRAINING':
          return new TrainingTargetValueConverter();
      }
    }

    return undefined;
  }
}
